import React, { useState } from 'react';

import { Box, COLORS, Text } from '@clutter/clean';

import { PasswordForm } from '@portal/components/password/password_form';
import { CUSTOMER_POST_BOOKING_SIGN_IN } from '@portal/config/customer';
import { client } from '@portal/libraries/apollo';
import { Status, usePasswordResetMutation } from '@portal/schema';

export const PasswordEditForm: React.FC<{
  token: string;
  onSave(): void;
}> = ({ token, onSave: onEdit }) => {
  const [execute, { loading, data }] = usePasswordResetMutation({ client });
  const error = data?.result?.error;

  const save = async ({ password }: { password: string }) => {
    const response = await execute({
      variables: {
        input: {
          token,
          password,
        },
      },
    });

    const status = response.data?.result?.status;

    if (status === Status.Ok) onEdit();
  };

  return (
    <>
      <PasswordForm error={error} loading={loading} save={save} />
      {!CUSTOMER_POST_BOOKING_SIGN_IN && (
        <Box textAlign="center" margin="24px 0 0">
          <Text.Callout color={COLORS.storm}>
            By clicking Update Password, I agree to Clutter’s{' '}
            <a style={{ textDecoration: 'underline' }} href="https://www.clutter.com/legal/tos" target="_blank">
              Terms of Use.
            </a>
          </Text.Callout>
        </Box>
      )}
    </>
  );
};
